/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ServiceTypeWithVCDSEnum = 'VCDR' | 'VMCFS' | 'VCDS';

export const ServiceTypeWithVCDSEnum = {

    VCDR: 'VCDR' as ServiceTypeWithVCDSEnum,

    VMCFS: 'VMCFS' as ServiceTypeWithVCDSEnum,

    VCDS: 'VCDS' as ServiceTypeWithVCDSEnum
};

